/* BrightSmile: scroll reveal/pop-in animations disabled per store direction. */
(function(){
  function showAll(){
    document.querySelectorAll('.bs-reveal,.bs-reveal--scale,.bs-reveal--left,.bs-reveal--right').forEach(function(el){
      el.classList.add('bs-in');
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.transition = 'none';
    });
  }
  if (document.readyState !== 'loading') showAll();
  else document.addEventListener('DOMContentLoaded', showAll);
  document.addEventListener('shopify:section:load', showAll);
})();
